import { Loader } from "@googlemaps/js-api-loader";

class Map {
    constructor(el, url, nonce) {
        this.root = el;
        this.url = url;
        this.nonce = nonce;

        this.container = this.root.querySelector('[data-map--container]');
        this.autocompleteInput = this.root.querySelector('[data-map--autocomplete]');

        this.settings = {
            apiKey: null,
            coordinates: {
                lat: 50.718,
                lng: 4.317,
                zoom: 8,
            },
            styles: [],
        };

        this.init();
    }

    bind() {
        this.onPlaceChanged = this.onPlaceChanged.bind(this);
        this.autocomplete.addListener('place_changed', this.onPlaceChanged);
    }

    unbind() {}

    onPlaceChanged() {
        const lat = this.autocomplete.getPlace().geometry.location.lat();
        const lng = this.autocomplete.getPlace().geometry.location.lng();

        this.map.setCenter({lat, lng});
        this.map.setZoom(10);
    }

    async open(id) {
        const spot = this.spots.find(s => s.id === id);

        if (!spot?.file?.url) { return }

        window.open(spot.file.url, '_blank');
    }

    async init() {
        this.settings = await this.getSettings();
        this.spots = await this.getSpots();

        const loader = new Loader({
            apiKey: this.settings.apiKey,
            version: 'weekly',
            libraries: ['places'],
        });

        await loader.load();

        this.autocomplete = new google.maps.places.Autocomplete(this.autocompleteInput, {});
        this.map = new google.maps.Map(this.container, {
            backgroundColor: '#000000',
            center: {
                lat: this.settings.coordinates.lat,
                lng: this.settings.coordinates.lng,
            },
            disableDefaultUI: true,
            keyboardShortcuts: false,
            zoom: this.settings.coordinates.zoom,
            styles: this.settings.styles,
        });

        this.markers = [];
        this.spots.forEach(spot => {
            const { lat, lng } = spot.google_map_field;
            const hasFile = Boolean(spot?.file?.url);
            const link = spot?.link?.url;
            const marker = new google.maps.Marker({
                clickable: true,
                position: {
                    lat,
                    lng,
                },
                map: this.map,
            });


            marker['customData'] = { id: spot.id };

            if (hasFile) {
                marker.addListener('click', () => {
                    this.open(marker.customData.id);
                });
            } else {
                marker.addListener('click', () => {
                    if(link) {
                        window.location.href = link;
                    }
                });
            }
        });

        this.bind();
    }

    getSpots() {
        return new Promise((resolve, reject) => {
            const data = new FormData();
            data.append( 'action', 'map_get_spots' );
            data.append( '__wpnonce', this.nonce);

            fetch(__app.ajax_url, {
                method: 'POST',
                credentials: 'same-origin',
                body: data
            })
                .then((response) => response.json())
                .then((data) => {
                    resolve(data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    getSettings() {
        return new Promise((resolve, reject) => {
            const data = new FormData();
            data.append( 'action', 'map_get_settings' );
            data.append( '__wpnonce', this.nonce);

            fetch(__app.ajax_url, {
                method: 'POST',
                credentials: 'same-origin',
                body: data
            })
                .then((response) => response.json())
                .then((data) => {
                    resolve({
                        apiKey: data['api_key'],
                        styles: JSON.parse(data['styles']),
                        coordinates: {
                            lat: parseFloat(data['coordinates']['lat']),
                            lng: parseFloat(data['coordinates']['lng']),
                            zoom: parseInt(data['coordinates']['zoom']),
                        }
                    });
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
}

export default {
    when() {
        return document.querySelectorAll('[data-map]').length > 0
    },

    mounted() {
        document.querySelectorAll('[data-map]').forEach(map => {
            new Map(map, __app.ajax_url, __app.nonce)
        })
    },
}
